import { useCallback, useEffect } from "react";

import {
    CrossFlowActionSubjects,
    CrossFlowViewedScreenNames,
    CrossFlowViewedUIActionSubjectIDs
} from "@atlassian/surface-analytics-specs";
import { Editions, ProductKeys } from "@atlassiansox/asc-stargate";

import {
    WAC_GENERIC_TOUCHPOINT_COMPONENT_NAME,
    useFireEvent
} from "../../utils";

export const useCrossFlowFrontendTouchpointComponentViewed = ({
    screenName,
    productKey,
    fireOnMount,
    edition
}: {
    fireOnMount: boolean;
    screenName?: CrossFlowViewedScreenNames;
    productKey?: ProductKeys;
    edition?: Editions;
}) => {
    const { fireCrossFlowViewedUIEvent, fireUIEvent } = useFireEvent({
        productKey,
        fireOnMount,
        edition
    });
    const onCrossFlowComponentViewed = useCallback(
        ({
            componentType = "button",
            componentName
        }: {
            componentType?: CrossFlowActionSubjects;
            componentName?: CrossFlowViewedUIActionSubjectIDs;
        }) => {
            if (componentName && screenName && productKey) {
                fireCrossFlowViewedUIEvent(
                    {
                        action: "viewed",
                        actionSubject: componentType,
                        actionSubjectId: componentName
                    },
                    {
                        source: screenName,
                        recommendedProductIds: [productKey]
                    }
                );
            } else {
                fireUIEvent({
                    action: "viewed",
                    actionSubject: WAC_GENERIC_TOUCHPOINT_COMPONENT_NAME
                });
            }
        },
        [fireCrossFlowViewedUIEvent, fireUIEvent, productKey, screenName]
    );

    useEffect(() => {
        if (fireOnMount) {
            onCrossFlowComponentViewed({});
        }
    }, [onCrossFlowComponentViewed, fireOnMount]);

    return onCrossFlowComponentViewed;
};
